<template>
	<div :style="style" :id="id">
		<b-card :class="classList">
			<template slot="header">
				<template v-if=" !showCollapse">
					<span
						:class="`text-${title && title.length ? 'black' : 'muted'}`"
					>{{ title && title.length ? title : $t('unknown title') }}</span>
				</template>
				<div class="card-actions">
					<button type="button" v-if="!showCollapse" @click.prevent="removeList" :title="$t('Remove')">
						<font-awesome-icon :icon="`trash`" size="sm" />
					</button>
					<button
						type="button"
						:title="$t(showCollapse ? 'collapse': 'expand')"
						:class="showCollapse ? 'collapsed' : null"
						:aria-expanded="showCollapse ? 'true' : 'false'"
						:aria-controls="`${this.id}_collapse_${this.index}_${this.level + 1}`"
						@click.prevent="showCollapse = !showCollapse"
					>
						<font-awesome-icon :icon="`angle-${showCollapse ? 'down' : 'right'}`" size="sm" />
					</button>
				</div>
			</template>

			<b-collapse :id="`${this.id}_collapse_${this.index}_${this.level + 1}`" v-model="showCollapse" class="mt-2">
				<template>
					<tooltip label="type">
						<select class="form-control" v-model="type" @change="handleOnChange">
							<option
								v-for="(type, i) in types"
								v-text="$t(type.value)"
								:value="type.key"
								:selected="type.key == data.type"
								:key="`type-${i}`"
							></option>
						</select>
					</tooltip>

					<tooltip label="title">
						<b-form-group>
							<b-input-group>
								<b-input-group-prepend>
									<b-button variant="primary" title="emoji" @click.prevent="emoji_status = !emoji_status">
										<font-awesome-icon icon="grin" />
									</b-button>
								</b-input-group-prepend>
								<b-form-input
									:name="`list_title_${index}_${level}`"
									:class="{'is-invalid': errors.has(`list_title_${index}_${level}`)}"
									:placeholder="$t('Title')"
									v-model="title"
									@input="handleOnChange"
									v-validate="'required'"
								></b-form-input>
								<span
									v-if="errors.has(`list_title_${index}_${level}`)"
									class="invalid-feedback"
								>{{ $t('The title field is required') }}</span>
							</b-input-group>
						</b-form-group>
						<emojiv2 :show="emoji_status" @chosen="addEmoji" color="green" />
					</tooltip>

					<tooltip label="url" v-if="type == 'web_url'">
						<input
							type="url"
							:name="`list_url_${index}_${level}`"
							v-validate="{ url: { require_protocol: true }, required: true }"
							v-model="url"
							placeholder="https://www.example.com"
							:class="{'form-control': true, 'is-invalid': errors.has(`list_url_${index}_${level}`)}"
							@input="handleOnChange"
						/>

						<span
							v-if="errors.has(`list_url_${index}_${level}`)"
							class="invalid-feedback"
						>{{ $t( "the url field is not a valid url") }}</span>
					</tooltip>

					<tooltip label="post back" v-if="type == 'postback'">
						<input
							:name="`list_postback_${index}_${level}`"
							v-validate="{ required: true }"
							v-model="payload"
							:placeholder="$t('post back')"
							:class="{'form-control': true, 'is-invalid': errors.has(`list_postback_${index}_${level}`)}"
							@input="handleOnChange"
						/>

						<span
							v-if="errors.has(`list_postback_${index}_${level}`)"
							class="invalid-feedback"
						>{{ $t( "the postback field is required") }}</span>
					</tooltip>

					<b-button-group size="sm">
						<button
							:title="$t('remove')"
							type="button"
							@click.prevent="removeList"
							class="btn btn-sm btn-danger m-0 mb-4 mr-1"
						>
							<i class="fa fa-trash-o fa-sm"></i>
						</button>
						<button
							:title="$t('new')"
							v-if="type == 'nested'"
							@click.prevent="add"
							type="button"
							:disabled="addStatus"
							class="btn btn-sm btn-primary m-0 mb-4 mr-1"
						>
							<i class="fa fa-plus fa-sm"></i>
						</button>
					</b-button-group>

					<template v-if="type == 'nested'">
						<tree
							v-for="(list, i) in call_to_actions"
							:key="`${id}_child_${index}_${level+1}_${i}`"
							:id="`${id}_child_${index}_${level+1}_${i}`"
							:parent="parent['call_to_actions'][i]"
							:changed="changed"
							:data="list"
							@deleted="remove(call_to_actions, i)"
							:index="i"
							:level="level + 1"
						></tree>
					</template>
				</template>
			</b-collapse>
		</b-card>
	</div>
</template>
<script>
import {types, max_levels} from './shema'
import collection from '../../mixins/tree'

export default {
	props: ['data', 'index', 'level', 'parent', 'changed', 'id'],
	mixins: [collection],
	inject: ['$validator'],
	computed: {
		style() {
			if (this.level > 1) {
				return 'margin-left:' + this.level + 'rem'
			}
			return ''
		},
		classList() {
			return ['mb-4', 'pb-0', 'tree--card']
		},
	},
	data() {
		return {
			emoji_status: false,
			showCollapse: true,
			types: function() {
				if (this.level > max_levels) {
					return [
						{
							key: 'postback',
							value: 'Post Back',
						},
						{
							key: 'web_url',
							value: 'Web Url',
						},
					]
				}
				return types
			}.call(this),
			title: this.data.title || '',
			type: this.data.type || (this.level > max_levels ? 'postback' : 'postback'),
			payload: this.data.payload || '',
			url: this.data.url || '',
			webview_height_ratio: this.data.webview_height_ratio || 'full',
			call_to_actions: this.data.call_to_actions || [],
		}
	},
	methods: {
		removeList() {
			this.$emit('deleted', this.index)
		},
		handleOnChange() {
			try {
				this.parent = Object.assign(this.parent, this.filterElement())
				this.changed()
			} catch (e) {
				//
			}
		},
		addEmoji(emoji) {
			this.title += emoji
			this.emoji_status = false
			this.handleOnChange()
		},
		// id() {
		// 	return window.id()
		// },
	},
	mounted() {
		this.handleOnChange()
	},
}
</script>



